import { create } from 'zustand';

const SHOWN_KEY = 'referral:coachmarkShown';

function alreadyShown(): boolean {
  try {
    return localStorage.getItem(SHOWN_KEY) !== null;
  } catch {
    return false;
  }
}

interface CoachmarkState {
  open: boolean;
  show: () => void; // show once ever (first call only); persists the flag
  hide: () => void;
}

export const useReferralCoachmarkStore = create<CoachmarkState>((set) => ({
  open: false,
  show: () => {
    if (alreadyShown()) return;
    try {
      localStorage.setItem(SHOWN_KEY, String(Date.now()));
    } catch {
      /* storage blocked — still show this session */
    }
    set({ open: true });
  },
  hide: () => set({ open: false }),
}));
